import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Send } from 'lucide-react';
export function LeadCaptureForm() {
  const [formData, setFormData] = useState({
    nombre: '',
    empresa: '',
    ciudad: '',
    whatsapp: ''
  });
  const cities = ['Bogotá', 'Medellín', 'Cali', 'Barranquilla', 'Cartagena', 'Bucaramanga', 'Manizales', 'Pereira', 'Santa Marta', 'Otra'];
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Presentational only
    console.log('Form submitted:', formData);
    alert('Gracias por su interés. Nos pondremos en contacto pronto.');
    setFormData({
      nombre: '',
      empresa: '',
      ciudad: '',
      whatsapp: ''
    });
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
  return <section id="contacto" className="py-24 bg-bone border-t border-gray-200" data-id="element-104">
      <div className="max-w-4xl mx-auto px-6 md:px-12" data-id="element-105">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-white p-10 md:p-16 shadow-2xl rounded-sm border border-gray-100 relative overflow-hidden" data-id="element-106">
          {/* Decorative accent */}
          <div className="absolute top-0 left-0 w-full h-2 bg-gold" data-id="element-107"></div>

          <div className="text-center mb-10" data-id="element-108">
            <h2 className="text-3xl md:text-4xl font-bold text-espresso mb-4" data-id="element-109">
              ¿Tiene un proyecto en desarrollo?
            </h2>
            <p className="text-espresso/70 text-lg font-light" data-id="element-110">
              Solicite hoy una asesoría técnica para presupuestos corporativos o
              residenciales de alta gama.
            </p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-6" data-id="element-111">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-112">
              <div data-id="element-113">
                <label htmlFor="nombre" className="block text-sm font-medium text-espresso mb-2" data-id="element-114">
                  Nombre Completo
                </label>
                <input type="text" id="nombre" name="nombre" required value={formData.nombre} onChange={handleChange} className="w-full px-4 py-3 border border-gray-300 focus:border-gold focus:ring-1 focus:ring-gold outline-none transition-colors bg-bone/50" placeholder="Ej. Juan Pérez" data-id="element-115" />
              </div>
              <div data-id="element-116">
                <label htmlFor="empresa" className="block text-sm font-medium text-espresso mb-2" data-id="element-117">
                  Empresa / Proyecto
                </label>
                <input type="text" id="empresa" name="empresa" required value={formData.empresa} onChange={handleChange} className="w-full px-4 py-3 border border-gray-300 focus:border-gold focus:ring-1 focus:ring-gold outline-none transition-colors bg-bone/50" placeholder="Nombre de su constructora o proyecto" data-id="element-118" />
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-119">
              <div data-id="element-120">
                <label htmlFor="ciudad" className="block text-sm font-medium text-espresso mb-2" data-id="element-121">
                  Ciudad
                </label>
                <select id="ciudad" name="ciudad" required value={formData.ciudad} onChange={handleChange} className="w-full px-4 py-3 border border-gray-300 focus:border-gold focus:ring-1 focus:ring-gold outline-none transition-colors bg-bone/50 appearance-none" data-id="element-122">
                  <option value="" disabled data-id="element-123">
                    Seleccione una ciudad
                  </option>
                  {cities.map(city => <option key={city} value={city} data-id="element-124">
                      {city}
                    </option>)}
                </select>
              </div>
              <div data-id="element-125">
                <label htmlFor="whatsapp" className="block text-sm font-medium text-espresso mb-2" data-id="element-126">
                  WhatsApp
                </label>
                <input type="tel" id="whatsapp" name="whatsapp" required value={formData.whatsapp} onChange={handleChange} className="w-full px-4 py-3 border border-gray-300 focus:border-gold focus:ring-1 focus:ring-gold outline-none transition-colors bg-bone/50" placeholder="+57 300 000 0000" data-id="element-127" />
              </div>
            </div>

            <div className="pt-4 text-center" data-id="element-128">
              <button type="submit" className="inline-flex items-center justify-center bg-gold hover:bg-gold-light text-espresso font-semibold px-8 py-4 text-lg transition-all duration-300 w-full md:w-auto rounded-sm" data-id="element-129">
                Solicitar Asesoría
                <Send className="ml-2 w-5 h-5" data-id="element-130" />
              </button>
            </div>
          </form>
        </motion.div>
      </div>
    </section>;
}